var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_973_5420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0899 51.7854L69.8454 42.0298C70.9533 40.922 70.9533 39.1359 69.8454 38.0281C68.7376 36.9203 66.9516 36.9203 65.8437 38.0281L56.0882 47.7837L46.3326 38.0281C45.2248 36.9203 43.4387 36.9203 42.3309 38.0281C41.223 39.1359 41.223 40.922 42.3309 42.0298L52.0864 51.7854L42.3309 61.541C41.223 62.6488 41.223 64.4349 42.3309 65.5427C42.8848 66.0966 43.6082 66.3679 44.3317 66.3679C45.0552 66.3679 45.7787 66.0966 46.3326 65.5427L56.0882 55.7871L65.8437 65.5427C66.3976 66.0966 67.1211 66.3679 67.8446 66.3679C68.5681 66.3679 69.2915 66.0966 69.8454 65.5427C70.9533 64.4349 70.9533 62.6488 69.8454 61.541L60.0899 51.7854Z",
    fill: "#FFDAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7628 43.0005L10.9046 31.1536C9.86463 30.1136 9.66115 28.4067 10.5994 27.2649C11.6733 25.9536 13.6176 25.8745 14.7933 27.0502L24.775 37.0205L47.8809 13.9146C48.9209 12.8746 50.6278 12.6711 51.7809 13.6094C53.0921 14.6833 53.1713 16.6276 51.9956 17.8033L26.7758 43.0005C25.668 44.1083 23.8706 44.1083 22.7515 43.0005H22.7628Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_973_5420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.67,
    height: 53.3674,
    fill: "white",
    transform: "translate(10 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIcon);
export default __webpack_public_path__ + "static/media/status-icon.bd98adc1e29bc4111f537e8c1a5ee4ab.svg";
export { ForwardRef as ReactComponent };